<tds-modal #modalEl (tdsClose)="close('closed')">
  <span slot="body">
    @if (config.content) {
    <ng-container *ngTemplateOutlet="config.content"></ng-container>
    } @else { {{ config.body }} }
  </span>

  <span slot="actions" class="tds-u-flex tds-u-gap1">
    @for (a of actions; track a.text) {
    <tds-button
      [text]="processingAction() === a ? (a.processingText ?? a.text) : a.text"
      size="md"
      [variant]="a.variant"
      [disabled]="processingAction() !== null"
      (click)="onActionClick(a)"
    ></tds-button>
    }
  </span>
</tds-modal>
